import styled from 'styled-components'
import { Button } from 'antd'

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`

export const SectionTitle = styled.h4`
  margin: 16px 0 8px;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 4px;
`

export const ImagesRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
`

export const ImageField = styled.div`
  display: flex;
  flex-direction: column;
`

export const ImageLabel = styled.span`
  margin-bottom: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`

export const StyledButton = styled(Button)`
  align-self: flex-end;
`
